import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import Vuex from 'vuex'
Vue.use(Vuex)

// bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/css/custom.scss"
import "./assets/css/theme.scss"

import VueOwlCarousel from 'vue-owl-carousel';
Vue.use(VueOwlCarousel)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

try {
  const raw = localStorage.getItem('vuex')
  const parsed = raw ? JSON.parse(raw) : {}
  const mode = parsed.theme === 'dark' ? 'dark' : 'light'
  document.documentElement.setAttribute('data-theme', mode)
  document.documentElement.style.colorScheme = mode
} catch (e) {
  document.documentElement.setAttribute('data-theme', 'light')
  document.documentElement.style.colorScheme = 'light'
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
